// extracted by mini-css-extract-plugin
export default {"hoverable":"style_hoverable__FJKr3","menuIcon":"style_menuIcon__cqWoM","badgeCount":"style_badgeCount__j1TTz"};